import { ISearchCommandOptions } from '@llws/dynamic-router-utils';
import { IBuildings } from '@llws/lift-entity-interfaces';
import { IApiDefaultMeta } from '@llws/platform-shared-types';
import config from '@/config';
import { IApiResponse, IGenericObject, IMetaResponse } from '@/shared';
import { baseRequest } from './base-request';
import { adminRequest } from './admin-request';

export interface IRequestConfig<T extends IGenericObject> {
  getOne?: ((path: string, querystring: string) => Promise<IApiResponse<T, IMetaResponse>>);
  get: ((path: string, querystring: string) => Promise<IApiResponse<T | T[], IMetaResponse>>);
  post: ((path: string, data: T | T[]) => Promise<IApiResponse<T | T[], IMetaResponse>>);
  postAll: ((data: T[]) => Promise<IApiResponse<T[], IMetaResponse>>);
  put: ((path: string, data: T | T[]) => Promise<IApiResponse<T | T[], IMetaResponse>>);
  putAll: ((data: T[]) => Promise<IApiResponse<T[], IMetaResponse>>);
  patch: ((path: string, data: T | T[]) => Promise<IApiResponse<T | T[], IMetaResponse>>);
  delete: ((path: string, ids: number[]) => Promise<IApiResponse<T | T[], IMetaResponse>>);
}

export const propertyRequest = {
  /**
   * @param path - The path to request
   * @param querystring - The querystring to pass to the request. Must be prefixed with '?'!
   */
  get: async (path: string, querystring: string = ''): Promise<IApiResponse<any, IMetaResponse>> => baseRequest.get(
    `${config?.adminGateway}/property-api/properties${path}`,
    querystring,
  ),
  search: (data: ISearchCommandOptions): Promise<IApiResponse<IBuildings[], IApiDefaultMeta>> => baseRequest.post(
    `${config?.adminGateway}/v1/property-api/properties/_search`,
    data,
  ),
  post: (path: string, data: IGenericObject): Promise<IApiResponse<any, any>> => baseRequest.post(
    `${config?.adminGateway}/property-api/properties${path}`,
    data,
  ),
  postAll: (data: IGenericObject[]): Promise<IApiResponse<any, any>[]> => Promise.all(
    data.map(async (building) => adminRequest.post(`/property-api/properties/`, [building])),
  ),
  put: (path: string, data: IGenericObject): Promise<IApiResponse<any, any>> => baseRequest.put(
    `${config?.adminGateway}/property-api/properties${path}`,
    data,
  ),
  putAll: (data: IGenericObject[]): Promise<IApiResponse<any, any>[]> => Promise.all(
    data.map(async (building) => adminRequest.put(`/property-api/properties/${building.id}`, [building])),
  ),
  patch: (path: string, data: IGenericObject): Promise<IApiResponse<any, any>> => baseRequest.patch(
    `${config?.adminGateway}/property-api/properties${path}`,
    data,
  ),
  delete: (path: string, ids: number[]): Promise<IApiResponse<any, any> | null> => baseRequest.delete<IApiResponse<any, any>>(
    `${config?.adminGateway}/property-api/properties${path}/${ids.join(',')}`,
  ),
};
